export const ES_TRANSLATIONS = {
  "language": {
    "genCode": "es",
    "localeCode": "es",
    "name": "Español"
  },
  "header": {
    "login": "Iniciar sesión",
    "register": "Registrarse",
    "help": "Ayuda",
    "assessment": "Evaluación",
    "continueIbis": "Continuar a IBIS",
    "students": "Estudiantes",
    "requestResults": "Solicitar reemplazo de resultados",
    "copyright": "© Organización del Bachillerato Internacional, 2026",
    "languagePolicy": "Política lingüística",
    "terms": "Términos y condiciones",
    "privacy": "Política de privacidad del IB",
    "myIB": "Mi IB",
    "store": "Tienda virtual",
    "blogs": "Blogs",
    "askQuestion": "¿Tiene alguna pregunta?",
    "ibis": "Sistema de información del IB"
  },

  "auth": {
    "welcome": "Bienvenido.",
    "movedSystem": "Hemos migrado a un sistema de inicio de sesión más seguro y simplificado.",
    "firstTime": "Es la primera vez que utilizas el nuevo sistema",
    "setupPassword": "Configurar nueva contraseña",
    "alreadySetup": "Ya has configurado una nueva contraseña",
    "fantastic": "¡Fantástico! Ahora puedes iniciar sesión con tu nueva contraseña."
  },

  "register": {
    "title": "Crear mi cuenta",
    "alreadyAccount": "¿Ya tienes una cuenta?",
    "loginHere": "Inicia sesión aquí",
    "troubleAccess": "¿Tienes problemas para acceder a tu cuenta?",
    "contactUs": "Contáctanos",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "salutation": "Tratamiento",
    "dob": "Fecha de nacimiento",
    "countryOfBirth": "País o territorio de nacimiento",
    "placeOfBirth": "Lugar de nacimiento",
    "preferredLanguage": "Idioma preferido",
    "selectOption": "Seleccionar una opción",
    "emailWarning": "Advertencia: tu correo electrónico será tu nombre de usuario.",
    "emailLongTerm": "Elige un correo al que tengas acceso a largo plazo.",
    "email": "Correo electrónico",
    "confirmEmail": "Confirmar correo electrónico",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "schoolEmail": "Correo electrónico escolar",
    "connectedAccount": "Conectado a tu cuenta",
    "agreeTerms": "Acepto los Términos y Condiciones del IB",
    "submit": "Crear mi cuenta",
    "privacyNote": "Los datos personales se gestionarán conforme a la política de privacidad del IB",
    "warningTitle": "Advertencia:",
    "warningText": "Tu correo electrónico será tu nombre de usuario único.",
    "warningNote": "Elige un correo electrónico al que tengas acceso a largo plazo.",
    "warningLastPrefix": "Para cambiar esta información más adelante, deberás",
    "warningLastLink": "solicitar un cambio manual.",
    "select": "Ninguno",
    "agree": "Acepto",
    "terms": "IB’s Términos y Condiciones",
    "privacyPrefix": "Los datos personales se gestionarán conforme a",
    "privacyLink": "la política de privacidad del IB"
  },

  "success": {
    "title": "¡Casi listo!",
    "accountReady": "Ahora puedes acceder a MY IB y al resto de herramientas del IB.",
    "confirmEmail": "Le hemos enviado un correo con las instrucciones de acceso a Mi IB. Compruebe su bandeja de entrada y siga los pasos indicados.",
    "arrivalTime": "Debería recibirlo en unos minutos.",
    "startBrowsing": "Volver al inicio de sesión"
  },

  "confirmation": {
    "emailSent": "Le hemos enviado un correo con las instrucciones de acceso a Mi IB. Compruebe su bandeja de entrada y siga los pasos indicados."
  },

  "common": {
    "back": "Atrás",
    "cancel": "Cancelar",
    "backToLogin": "Volver al inicio de sesión"
  },

  "login": {
    "email": "Correo electrónico",
    "password": "Contraseña",
    "login": "Iniciar sesión",
    "noAccount": "¿No tienes una cuenta?",
    "registerNow": "Regístrate ahora."
  },

  "passwordReset": {
    "title": "Configura tu nueva contraseña",
    "instruction": "Debes restablecer tu contraseña la primera vez que inicies sesión.",
    "emailAddress": "Dirección de correo electrónico",
    "next": "Siguiente",
    "verifyOtp": "Verificar OTP",
    "otpInstruction": "Introduce el código de 6 dígitos enviado a tu correo",
    "otpSentTo": "Código enviado a",
    "enterOtp": "Ingresar código",
    "resendOtp": "Reenviar código",
    "resetPassword": "Restablecer contraseña",
    "resettingFor": "Restableciendo contraseña para",
    "newPassword": "Nueva contraseña",
    "enterNewPassword": "Ingresar nueva contraseña",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "securityVerification": "Verificación de seguridad",
    "verificationSuccess": "Verificación exitosa"
  },
  "errors": {
    "required": "{field} es obligatorio.",
    "passwordPattern": "La contraseña debe contener una letra mayúscula, un número y un carácter especial.",
    "invalidEmail": "Introduce un correo electrónico válido.",
    "invalidDate": "Introduce una fecha de nacimiento válida. Debes tener al menos 18 años.",
    "invalidLeapYearDate": "Introduzca una fecha de nacimiento válida. El 29 de febrero solo es válido en un año bisiesto.",
    "invalidDateFormat": "El formato de la fecha de nacimiento no es válido. Por favor, utiliza el formato DD/MM/YYYY.",
    "emailMismatch": "El correo y su confirmación deben coincidir.",
    "passwordMismatch": "La contraseña y su confirmación deben coincidir.",
    "minLength": "Se requieren al menos {{length}} caracteres.",
    "maxLength": "No debe superar los {{max}} caracteres.",
    "linkNotWorking": "Este enlace ya no funciona. Solicite uno nuevo.",
    "requiredFieldsInvalid": "Verifique que todos los campos obligatorios estén completados correctamente.",
    "acceptTerms": "Por favor, acepte los Términos y Condiciones para continuar.",
    "genericServerError": "Se ha producido un error. Inténtelo de nuevo en unos minutos.",
    "linkAlreadyUsed": "Este enlace ya se ha utilizado. Utilice la opción de inicio de sesión.",
    "emailAlreadyUsed": "Ya existe un registro con estos detalles.",
    "nameTooLong": "Su nombre es demasiado largo. La extensión máxima es de 40 caracteres.",
    "invalidInformation": "Parte de la información no es correcta. Revísela y vuelva a intentarlo.",
    "sessionVerificationFailed": "No se pudo verificar su inicio de sesión. Actualice la página y vuelva a intentarlo.",
    "tooManyAttempts": "Se ha superado el número de intentos. Espere un momento y vuelva a iniciar sesión.",
    "registrationUnavailable": "No es posible completar el registro en este momento. Inténtelo de nuevo en unos minutos.",
    "offline": "Parece que no tiene conexión. Verifique su conexión e inténtelo de nuevo.",
    "weakPassword": "La contraseña que ha introducido no está permitida. Elija una contraseña diferente."
  }
} as const;
